export default {
  items: [
    "English",
    "Australian",
    "Irish",
    "Scottish",
    "Italian",
    "Chinese",
    "German",
    "Dutch",
    "Indian",
    "New Zealander",
    "South African",
    "Filipino",
    "Polish",
    "Welsh",
    "Croatian",
    "Vietnamese",
    "Greek",
    "French",
    "Macedonian",
    "Burmese",
    "Portuguese",
    "Malay",
    "Indonesian",
    "American",
    "Spanish",
    "Serbian",
    "Thai",
    "Japanese",
    "Danish",
    "Korean",
    "Russian",
    "Anglo-Indian",
    "Hungarian",
    "Maltese",
    "Mauritian",
    "Iranian",
    "Zimbabwean",
    "Timorese",
    "Maori",
    "Swedish",
    "Afghan",
    "Ukrainian",
    "Lebanese",
    "Arab, nfd",
    "Norwegian",
    "Sudanese",
    "Romanian",
    "Pakistani",
    "Tamil, nfd",
    "Iraqi",
    "Egyptian",
    "Singaporean",
    "Somali",
    "Chilean",
    "Latvian",
    "Turkish",
    "Samoan",
    "Czech",
    "Khmer (Cambodian)",
    "Sinhalese",
    "Finnish",
    "Jewish",
    "Brazilian",
    "Belgian",
    "Ethiopian",
    "Karen",
    "Lithuanian",
    "Nepalese",
    "Burundian",
    "Salvadoran",
    "Papua New Guinean",
    "Slovene",
    "Palestinian",
    "Argentinian",
    "Hazara",
    "Australian Aboriginal and Torres Strait Islander",
    "Australian South Sea Islander"
  ]
}



// WEBPACK FOOTER //
// ../data/qld/ancestry.js